import { Link } from "react-router-dom";
import { Menu } from "lucide-react";

const LOGO_URL = "/smartdienstplan-logo.svg";

const AppHeader = ({
  leading,
  onMobileMenuClick,
  mobileMenuAriaLabel = "Menue oeffnen",
  center,
  actions,
  homePath = "/dienstplan",
  logoRight = false,
  logoClassName = "w-7 h-7",
  showBrandText = true,
  containerClassName = "max-w-6xl mx-auto px-6 h-16 flex items-center gap-3",
  brandClassName = "font-heading font-semibold text-white text-lg",
}) => {
  const logoBlock = (
    <Link to={homePath} className={`flex items-center gap-2 mr-3 ${logoRight ? "w-full justify-end" : ""}`}>
      <img src={LOGO_URL} alt="smartdienstplan" className={logoClassName} />
      {showBrandText ? (
        <span className={brandClassName}>smartdienstplan</span>
      ) : null}
    </Link>
  );

  return (
    <header className="bg-[#212529] sticky top-0 z-10">
      <div className={containerClassName}>
        {leading ? leading : null}
        {logoRight ? null : logoBlock}
        {center ? <div className="hidden md:flex items-center gap-2">{center}</div> : null}
        {(onMobileMenuClick || actions) ? (
          <div className="ml-auto flex items-center gap-3">
            {onMobileMenuClick ? (
              <button
                type="button"
                className="lg:hidden h-14 w-14 rounded-full border border-white/35 bg-white/10 text-white inline-flex items-center justify-center hover:bg-white/20"
                onClick={onMobileMenuClick}
                aria-label={mobileMenuAriaLabel}
              >
                <Menu className="w-6 h-6" />
              </button>
            ) : null}
            {actions}
          </div>
        ) : null}
        {logoRight ? logoBlock : null}
      </div>
    </header>
  );
};

export default AppHeader;
